import React from 'react';
import { Icon, Spin } from 'antd';
import Rectangle from 'react-rectangle';
import VideoPlayerComponent from '../../../../shared/components/VideoPlayerComponent'
import SpecificationAlert from '../../../../shared/components/SpecificationAlert';
import DynamicContentLink from '../../../../shared/components/DynamicContentLink';
import Colors from '../../../../../themes/Colors';
import {
  contentPreviewSource,
  isDynamicContent,
  isVideoPreview
} from '../../../../../services/contents';

/**
 * Renders the visual preview of the content (image/video/loading) within the screen slot.
 * Extracted from RelationSliderComponent (getImage function).
 */
const RelationMediaPreview = ({ relation, display, programmatic }) => {
  if (!relation.content) return null;

  const isExactSize =
    relation.content.width === display.resolution_width &&
    relation.content.height === display.resolution_height;
  const isPendingContent = relation.isPendingContent;
  const isInactive = relation.active === 0;
  // A dynamic ad is an HTML page served from an external URL: the slot shows the
  // uploaded preview (a still or a clip), never the page itself. The Rectangle keeps
  // the screen's aspect ratio, which is right — the HTML adapts to it.
  const isDynamic = isDynamicContent(relation.content.type);
  const previewSource = contentPreviewSource(relation.content);

  return (
    <div className="screenContainer">
      <Rectangle aspectRatio={[display.resolution_width, display.resolution_height]}>
        {/* Dynamic (DCO) */}
        {isDynamic && (
          <div
            className="screen"
            style={{ filter: isPendingContent || isInactive ? 'brightness(0.5)' : 'none' }}
          >
            {previewSource ? (
              isVideoPreview(relation.content) ? (
                <video
                  src={previewSource}
                  className="screenPreviewFilled"
                  autoPlay
                  muted
                  loop
                />
              ) : (
                <img
                  src={previewSource}
                  className="screenPreviewFilled"
                  alt=""
                />
              )
            ) : (
              // No preview yet (or its transcoding failed): the Spin below covers the
              // pending case, so the icon only stands in for a preview that will not come.
              relation.content.ready && (
                <Icon type="global" style={{ fontSize: 32, color: Colors.primaryAccent }} />
              )
            )}
          </div>
        )}

        {/* Image */}
        {relation.content.type === 'image' && (
          <div
            className="screen"
            style={{ filter: isPendingContent || isInactive ? 'brightness(0.5)' : 'none' }}
          >
            <img
              src={
                relation.content && relation.content.ready
                  ? relation.content.file_thumb.replace('.mp4', '-00001.jpg')
                  : null
              }
              className={
                isExactSize || relation.fill_screen ? 'screenPreviewFilled' : 'screenPreview'
              }
              alt=""
            />
          </div>
        )}

        {/* Video */}
        {relation.content && relation.content.ready && relation.content.type === 'video' && (
          <VideoPlayerComponent
            relation={relation}
            forceFill={isExactSize || relation.fill_screen}
          />
        )}

        {/* Loading */}
        {relation.content && relation.content.id && !relation.content.ready && (
          <div className="pulseLoaderContainer">
            <Spin size="large" spinning />
          </div>
        )}
      </Rectangle>

      <SpecificationAlert
        programmatic={programmatic}
        slotLength={display.slot_length}
        contentLength={relation.content.length}
        contentType={relation.content.type}
        pricePerDay={display.price_per_day}
        formatSettings={display.format_settings}
      />
    </div>
  );
};

export default RelationMediaPreview;
